<template>
  <v-dialog max-width="800">
    <template v-slot:activator="{on, attrs}">
      <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
    </template>
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title v-if="operation === 'create'" class="white--text">Ajouter une entreprise</v-toolbar-title>
        <v-toolbar-title v-else class="white--text">Mettre à jour l'entreprise</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form ref="entrepriseForm">
          <v-text-field :rules="[notNullNorEmpty]" v-model="entreprise.name" label="Nom de l'entreprise"></v-text-field>
          <v-text-field :rules="[notNullNorEmpty]" v-model="entreprise.email" label="E-mail"></v-text-field>
          <v-text-field :rules="[notNullNorEmpty]" v-model="entreprise.tel" label="Téléphone"></v-text-field>
          <v-text-field :rules="[notNullNorEmpty]" v-model="entreprise.siret" label="SIRET"></v-text-field>
          <v-select multiple item-text="name" item-value="id" label="Métiers" v-model="entreprise.metiers" :items="categories"></v-select>
          <v-textarea :rules="[notNullNorEmpty]" v-model="entreprise.adresse" label="Adresse"></v-textarea>
          <span class="body-2">Informations financières</span>
          <v-text-field :rules="[value => value !== null && value.indexOf(' ') === -1 || 'Pas d\'espace dans l\'IBAN.']" v-model="entreprise.iban" label="IBAN"></v-text-field>
          <v-text-field v-model="entreprise.bic" label="BIC"></v-text-field>
          <v-divider></v-divider>
          <v-textarea v-model="entreprise.note" label="Note"></v-textarea>
        </v-form>

      </v-card-text>
      <v-card-actions>
        <v-btn v-if="operation === 'create'" @click="addEntreprise" color="primary">Ajouter l'entreprise</v-btn>
        <v-btn v-else @click="updateEntreprise" color="primary">Mettre à jour l'entreprise</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ValidationRulesMixin} from "@/mixins/ValidationRulesMixin";
import {EntrepriseRepository} from "@/repository/entreprises";

export default {
  name: "EntrepriseDialog",
  mixins: [ValidationRulesMixin],
  props: {
    operation: {
      type: String,
      default: () => "create",
    },
    entrepriseObject: {
      type: Object,
      default: () => {},
    }
  },
  async mounted() {
    if (this.$store.getters["category/loading_status"] !== "LOADED") {
      await this.$store.dispatch("category/fetchCategory");
    }
  },
  data() {
    let entrepriseModel = this.operation === 'update' ? JSON.parse(JSON.stringify(this.entrepriseObject)) : {
        name: "",
        adresse: "",
        tel: "",
        email: "",
        siret: "",
        metiers: [],
        note: "",
        iban: "",
      };
    entrepriseModel.metiers = entrepriseModel.metiers.map((metier) => metier.id);

    return {
      repository: new EntrepriseRepository(),
      entreprise: entrepriseModel,
    }
  },
  computed: {
    categories() {
      return this.$store.getters["category/categories"];
    }
  },
  methods: {
    async addEntreprise() {
      if (this.$refs.entrepriseForm.validate()) {
        let result = await this.repository.post(this.entreprise);
        await this.$router.push(`/entreprises/${result.id}`);
        await this.$store.dispatch("annonce/annonceSuccess", "Entreprise créée");
      }
    },
    async updateEntreprise() {
      if (this.$refs.entrepriseForm.validate()) {
        await this.repository.update(this.entreprise);
        this.$emit("reload");
        await this.$store.dispatch("annonce/annonceSuccess", "Entreprise mise à jour");
      }
    }
  }
}
</script>

<style scoped>

</style>